import { Component, ElementRef, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { MultiCartService } from '@spartacus/cart/base/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType, OCC_CART_ID_CURRENT, TranslationService } from '@spartacus/core';
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { UigActiveCartService } from 'src/app/services/uig-active-cart.service';
import { UigCartService } from '../uig-cart.service';

@Component({
    selector: 'app-uig-empty-cart',
    templateUrl: './uig-empty-cart.component.html',
    styleUrls: ['./uig-empty-cart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigEmptyCartComponent implements OnDestroy {

  @ViewChild('dialog', {read: ElementRef})
  dialog: ElementRef;
  public readonly eIconTypes = ICON_TYPE;
  activeCartId: string;
  entriesSubscription: Subscription = new Subscription();
  deletionSubscription: Subscription = new Subscription();
  isDeleting$ = new BehaviorSubject(false);
  removeAllEntries$: Observable<Object>;
  getEntries$: Observable<OrderEntry[]> = this.uigActiveCartService.getEntries();
  activeCartSubscription: Subscription = new Subscription();

  constructor(
    private uigActiveCartService: UigActiveCartService,
    private uigCartService: UigCartService,
    private multiCartService: MultiCartService,
    private translation: TranslationService,
    private messageService: GlobalMessageService,
    private launchDialogService: LaunchDialogService
  ) {
    this.activeCartSubscription = this.uigActiveCartService.getActiveCartId().pipe(
      filter((activeCartId) => activeCartId != null),
      tap((activeCartId) => {
        this.activeCartId = activeCartId;
      })
    )
    .subscribe();
  }

  ngOnDestroy(): void {
    this.entriesSubscription.unsubscribe();
    this.deletionSubscription.unsubscribe();
    this.activeCartSubscription.unsubscribe();
  }

  removeAllEntries() {
    this.entriesSubscription = this.getEntries$
      .pipe(take(1))
      .subscribe((entries) => {
        if (entries.length > 0) {
          this.isDeleting$.next(true);
          this.removeAllEntries$ = this.uigCartService.removeAllEntries(this.activeCartId);
          this.deletionSubscription = this.removeAllEntries$
            .pipe(
              tap(
                (success) => {
                  if (success == true) {
                    this.multiCartService.reloadCart(OCC_CART_ID_CURRENT);
                    this.isDeleting$.next(false);
                    this.launchDialogService.closeDialog(success);
                  } else {
                    this.isDeleting$.next(false);
                    this.launchDialogService.closeDialog(success);
                    this.translation
                      .translate('emptyCart.error')
                      .pipe(take(1))
                      .subscribe((message) => {
                        this.messageService.add(
                          message,
                          GlobalMessageType.MSG_TYPE_ERROR
                        );
                      });
                  }
                }
              )
            )
            .subscribe();
        }
      });
  }

  dismissModal(reason?: any): void {
    this.launchDialogService.closeDialog(reason);
}
}
